<button
  (click)="openHeatingSystemsOverview()"
  class="vi-button"
  color="primary"
  mat-flat-button>{{ 'APPOI.BUTTON.OPEN_INSTALLATIONS' | translate }}
</button>
